module.exports = __webpack_public_path__ + "static/img/2_1_5.3a383e01.jpg";